import styled, { keyframes } from "styled-components";
import { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
// Componentes personalizados
//import BlocoTituloTextoBotaoImagem from "../../components/BlocoTituloTextoBotaoImagem";
import { BotaoFaleConosco, BotaoReceberLigacao } from "../../components/Botoes";

import Form from "../../components/Form";
import SecaoPagina from "../../components/SecaoPagina";
import PageLayout from "../../layouts/PageLayout";

import TelasAplicacao from "../../assets/imagens/waiter/Telas_conjunto.png";
import LogoProduto from "../../assets/imagens/waiter/logo_sifat_waiter4.png";
import MonitorHomeWaiter from "../../assets/imagens/waiter/Monitor_Home_Waiter.webp";
import NotebookDashboard from "../../assets/imagens/waiter/Notebook_Dashboard.webp";
import MonitorProducao from "../../assets/imagens/waiter/Monitor_de_Producao.webp";
import WaiterBannerDiferenciais from "../../assets/imagens/waiter/Waiter_2.webp";

//----------teste 01
// Container principal com imagem de fundo e overlay escuro
const Section = styled.section`
  position: relative;
  width: 100%;
  padding: 5rem 1.5rem;
  background-image: url(${WaiterBannerDiferenciais});
  background-size: cover;
  background-position: left center;

  /* Overlay escuro para melhor contraste do texto */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.5) 100%
    );
    z-index: 1;
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1280px;
  margin: 0 auto;
`;

const Title2 = styled.h2`
  text-align: center;
  font-size: 2.8rem;
  font-weight: 800;
  letter-spacing: 2px;
  color: #ffffff;
  margin-bottom: 3rem;
  text-transform: uppercase;
  position: relative;
  display: inline-block;
  width: 100%;

  &::after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: #fcb432;
    margin: 1rem auto 0;
    border-radius: 4px;
  }
`;

// Grid responsiva para os 6 cards
const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(320px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
  justify-items: center;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    justify-items: stretch;
  }
`;

const Card2 = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem 1.5rem;
  box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  text-align: center;
  backdrop-filter: blur(0px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  grid-template-columns: repeat(3, 1fr);
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 25px 40px -12px rgba(0, 0, 0, 0.3);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr); // desktop (3 colunas)
  }
`;

const CardIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1.2rem;
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e2a3e;
  margin-bottom: 1rem;
`;

const CardDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  color: #4a5568;
  margin-bottom: 1.5rem;
`;

const SaibaMaisLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #e67e22;
  text-decoration: none;
  font-size: 0.95rem;
  transition: gap 0.2s;

  &:hover {
    gap: 0.8rem;
    color: #f9a826;
  }
`;

// Container dos botões principais
const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1rem;
`;

const ActionButton = styled.button`
  padding: 0.9rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: ${(props) => (props.primary ? "#e67e22" : "transparent")};
  color: ${(props) => (props.primary ? "#1e2a3e" : "#ffffff")};
  border: ${(props) => (props.primary ? "none" : "2px solid #ffffff")};
  box-shadow: ${(props) =>
    props.primary ? "0 8px 20px rgba(249, 168, 38, 0.3)" : "none"};

  &:hover {
    transform: scale(1.03);
    background: ${(props) =>
      props.primary ? "#e67e22" : "rgba(255, 255, 255, 0.1)"};
    border-color: ${(props) => (!props.primary ? "#e67e22" : "none")};
    color: ${(props) => (!props.primary ? "#e67e22" : "#ffffff")};
  }
`;

// Dados dos 6 cards (conforme os diferenciais do brief)
const diferenciais = [
  {
    id: 1,

    titulo: "Food Service Focus",
    descricao:
      "Focado e desenvolvido especialmente para food services, com soluções que atendem desde pequenos negócios até grandes redes.",
  },
  {
    id: 2,

    titulo: "Módulos de Atendimento",
    descricao:
      "Diversos módulos de atendimento para otimizar pedidos, delivery, self-service e muito mais.",
  },
  {
    id: 3,

    titulo: "Integração com Catracas",
    descricao:
      "Controle de acesso e fluxo de clientes com integração completa a catracas eletrônicas.",
  },
  {
    id: 4,

    titulo: "Integração com Balança",
    descricao:
      "Precisão e agilidade na pesagem de produtos, integração nativa com balanças inteligentes.",
  },
  {
    id: 5,

    titulo: "Emissão Fiscal Rápida",
    descricao:
      "Emissão fiscal simples e rápida, com suporte a NFC-e e integração contábil.",
  },
  {
    id: 6,

    titulo: "Gestão Inteligente",
    descricao:
      "Relatórios avançados, controle de estoque e indicadores para decisões mais assertivas.",
  },
];
//----------teste 01

//----------teste 00
const Container2 = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  padding: 60px 0px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    flex-direction: ${(props) =>
      props.$imageAlignment === "left" ? "column-reverse" : "column"};
    padding: 40px 20px;
    gap: 30px;
  }
`;

const ContainerTexto = styled.div`
  flex: 1;
  padding: ${(props) => props.$paddingTextContainer || "0"};

  @media (max-width: 1024px) {
    text-align: center;
  }
`;

const ContainerImagem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  order: ${(props) => (props.$imageAlignment === "left" ? 1 : 0)};

  @media (max-width: 1024px) {
    order: 0;
  }
`;

const Titulo = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: ${(props) => props.$corTitulo || "#000"};

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Paragrafo = styled.p`
  font-size: var(--medium-font);
  color: white;
  line-height: 1.4;
  margin-bottom: 30px;
  color: ${(props) => props.$corParagrafo || "#white"};
  font-weight: var(--regular-weight);

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
const SubParagrafo = styled.p`
  font-size: 1.4rem;
  color: white;
  line-height: 1.2;
  margin-bottom: 30px;
  color: ${(props) => props.$corParagrafo || "#white"};

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
const BotoesWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const ImagemMobile = styled.img`
  display: none;
  max-width: ${(props) => props.max || "100%"};
  margin: ${(props) => props.$margem || "0"};
  height: auto;

  @media (max-width: 1024px) {
    display: ${(props) => (props.$possuiImagem ? "block" : "none")};
    margin: 20px auto;
  }
`;

const ImagemDesktop = styled.img`
  display: block;
  max-width: ${(props) => props.max || "100%"};
  margin: ${(props) => props.$margem || "0"};
  height: auto;
  width: 100%;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const Imagem = styled.img`
  display: none;

  @media (max-width: 1024px) {
    display: ${(props) => (props.$possuiImagem ? "block" : "none")};
    max-width: ${(props) => props.max || "100%"};
    margin: ${(props) => props.$margem || "0"};
    height: auto;
  }
`;

const TextoAbaixoImagem = styled.p`
  text-align: center;
  margin-top: 20px;
  font-size: 1.2rem;
  font-weight: 600;
  color: ${(props) => props.$cor || "#1B5EA4"};
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-top: 15px;
  }
`;

function BlocoTituloTextoBotaoImagem({
  imagem,
  margemImagem,
  styleImagem,
  styleContainerImagem,
  possuiLogosClientes,
  botao1,
  botao2,
  corParagrafo,
  corTitulo,
  paragrafo1,
  paragrafo2,
  tituloTipoA, // preto e azul
  tituloTipoB, // branco
  titulo1,
  titulo2,
  max,
  paddingTextContainer,
  imageAlignment,
  textoAbaixoImagem, // texto que vai aparecer abaixo da imagem
  corTextoAbaixoImagem, // cor do texto abaixo da imagem
}) {
  return (
    <Container2 $imageAlignment={imageAlignment}>
      <ContainerTexto $paddingTextContainer={paddingTextContainer}>
        <Logo src={LogoProduto} />
        {tituloTipoA && (
          <Titulo $corTitulo={corTitulo}>
            {titulo1} <span style={{ color: "#1B5EA4" }}>{titulo2}</span>
          </Titulo>
        )}
        {tituloTipoB && (
          <Titulo $corTitulo={corTitulo}>
            <span style={{ color: "white" }}>{titulo1}</span>
          </Titulo>
        )}

        {imagem && (
          <Imagem
            $possuiImagem={imagem}
            src={imagem}
            $margem={margemImagem}
            alt="Imagem do título"
            max={max}
            style={styleImagem}
          />
        )}

        <Paragrafo $corParagrafo={corParagrafo}>
          {paragrafo1}

          <SubParagrafo $corParagrafo={corParagrafo}>{paragrafo2}</SubParagrafo>
        </Paragrafo>

        <BotoesWrapper>
          {botao1}
          {botao2 && botao2}
        </BotoesWrapper>
        {possuiLogosClientes}
      </ContainerTexto>

      <ContainerImagem
        $imageAlignment={imageAlignment}
        style={styleContainerImagem}
      >
        {imagem && (
          <ImagemDesktop
            $possuiImagem={imagem}
            src={imagem}
            $margem={margemImagem}
            alt="Imagem do título"
            max={max}
            style={styleImagem}
          />
        )}

        {/* Texto abaixo da imagem - igual à segunda imagem */}
        {textoAbaixoImagem && (
          <TextoAbaixoImagem $cor={corTextoAbaixoImagem}>
            {textoAbaixoImagem}
          </TextoAbaixoImagem>
        )}
      </ContainerImagem>
    </Container2>
  );
}

//-------teste 00

//  Animações
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(32px); }
  to   { opacity: 1; transform: translateY(0); }
`;

//  Tokens
const vermelho = "#870000";
const vermelhoClaro = "#a80000";
const cinzaFundo = "#EFEFEF";
const TransFundo = "#transparent";
const cinzaCard = "#FFFFFF";
const verde = "#88bd28";
const azul = "#1B5EA4";
const textoDark = "#1a1a1a";
const textoSub = "#555";

//  Utilitários
const Section2 = styled.section`
  width: 100%;
  background: ${({ $bg }) => $bg || cinzaFundo};
  display: flex;
  justify-content: center;
  padding: ${({ $py }) => $py || "5rem"} 1.5rem;
`;

const Inner = styled.div`
  max-width: 1100px;
  width: 100%;

  animation: ${fadeInUp} 0.7s ease both;
  animation-delay: ${({ $delay }) => $delay || "0s"};
`;

const SectionTitle = styled.h2`
  font-family: "Montserrat", sans-serif;
  font-size: clamp(1.5rem, 3vw, 2.1rem);─
  font-weight: 800;
  color: ${({ $cor }) => $cor || vermelho};
  margin: 0 0 0.35rem;
  letter-spacing: -0.02em;
`;

const SectionSubtitle = styled.p`
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  color: ${textoSub};
  margin: 0 0 2.5rem;
  line-height: 1.7;
  max-width: 640px;
`;

// BLOCOS DE PRODUTO

const ProdutosGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;

const ProdutoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  background: transparent;

  @media (min-width: 768px) {
    flex-direction: ${({ $reverso }) => ($reverso ? "row-reverse" : "row")};
    gap: 3.5rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;

const ProdutoTexto = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ProdutoNome = styled.h3`
  font-family: "Montserrat", sans-serif;
  font-size: clamp(1.2rem, 2.2vw, 1.55rem);
  font-weight: 800;
  color: ${vermelho};
  margin: 0;
`;

const ProdutoDescricao = styled.p`
  font-family: "Open Sans", sans-serif;
  font-size: 0.97rem;
  color: ${textoSub};
  line-height: 1.75;
  margin: 0;
`;

const BotaoSaiba = styled.b`
  display: inline-block;
  background: ${vermelho};
  color: #fff;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 0.88rem;
  letter-spacing: 0.03em;
  padding: 0.65rem 1.6rem;
  border-radius: 4px;
  text-decoration: none;
  align-self: flex-start;
  transition: background 0.2s;
  cursor: pointer;
  &:hover {
    background: ${vermelhoClaro};
  }
  @media (max-width: 768px) {
    align-self: center;
  }
`;

const ProdutoImagemWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProdutoImagem = styled.div`
  width: 100%;
  max-width: 480px;
  aspect-ratio: 16/9;
  background: transparent;
  aspect-ratio: 16/9
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(135, 0, 0, 0.13);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
`;

const IconeFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: ${({ $cor }) => $cor || "#aaa"};
`;

const IconeSVG = ({ tipo, imagemUrl }) => {
  // Se receber uma imagem URL, exibe a imagem
  if (imagemUrl) {
    return (
      <img
        src={imagemUrl}
        alt={`Ícone ${tipo}`}
        width="400"
        height="400"
        style={{ objectFit: "contain", background: "transparent" }}
      />
    );
  }

  // Fallback para os SVGs originais

  return null;
};
const produtos = [
  {
    nome: "Waiter PDV + Waiter PDV Mobile",
    descricao:
      "Tenha um PDV Completo para a realização dos seus pedidos de vendas do estabelecimento, além de poder utilizá-lo na versão mobile, oferecendo mobilidade e praticidade ao atendimento do seu Food Service.",
    tipo: "pdv",
    imagemUrl: MonitorHomeWaiter,
    reverso: false,
  },
  {
    nome: "ERP Completo",
    descricao:
      "Administre o seu Food Service por completo com o Sifat ERP (Desktop) e o Sifat ERP Mobile que permite o acompanhamento completo das movimentações do empreendimento, assim como o acesso a relatórios completos.",
    tipo: "erp",
    imagemUrl: NotebookDashboard,
    reverso: false,
  },
  {
    nome: "Monitor de Produção Mobile",
    descricao:
      "Tenha um monitor em cada local de produção a fim de garantir maior eficiência nos processos diários do negócio, realize os pedidos no Waiter e encaminhe para a cozinha, via monitor de produção mobile.",
    tipo: "monitor",
    imagemUrl: MonitorProducao,
    reverso: false,
  },
];

const Logo = styled.img`
	width: 4em;
	height: auto;
	margin-top: -10em;
	margin-bottom: -5em;

	@media screen and (min-width: 993px) {
		margin-right: auto;
	}
`;

// ─── 2. INTEGRAÇÕES

const IntegracoesWrapper = styled.div`
  text-align: center;
`;

const IntegracoesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
`;

const IntegracaoCard = styled.div`
  background: ${vermelho};
  color: #fff;
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 1.05rem;
  letter-spacing: 0.04em;
  padding: 1rem 2rem;
  border-radius: 6px;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  transition:
    transform 0.18s,
    background 0.18s;
  cursor: default;

  &:hover {
    background: ${vermelhoClaro};
    transform: translateY(-3px);
  }

  span.sub {
    font-size: 0.68rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
    letter-spacing: 0.06em;
    text-transform: lowercase;
  }
`;

const IntegracoesSection = styled.section`
  width: 100%;
  background: #f5f5f5;
  padding: 4rem 1.5rem;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-family: "Montserrat", sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: #870000;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;

  @media (max-width: 640px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const Card = styled.div`
  background: #870000;
  border-radius: 17px;
  color: white;
  padding: 1rem;
  width: 16em;
  text-align: center;
  margin-bottom:0rem
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(135, 0, 0, 0.1);
  }
   @media (max-width: 640px) { 
   margin-bottom:2rem
   }
`;

const IntegracaoNome = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  color: white;
  margin-bottom: -1rem;
  font-family: "Montserrat", sans-serif;
`;

const Botao = styled.a`
  display: inline-block;
  background: #ffd700;
  position: relative;
  bottom: -3em;
  border-radius: 17px;
  color: white;
  padding: 0rem 0.3rem;
  width: 10em;
  padding: 1rem;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    background: #e09612;
    transform: scale(1.05);
  }
`;
const SpanSaibaMais = styled.button`
  color: white;
  font-size: 1.4rem;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  background: transparent;
  border: none;
  text-decoration: none;
  backg &:hover {
    text-decoration: underline;
  }
`;
function SecaoIntegracoes({ rolarParaFormulario }) {
  const navigate = useNavigate();
  const integracao_Click = (item) => {
    if (item.nome === "WAYMENU") {
      navigate(item.link);
    } else {
      rolarParaFormulario();
    }
  };
  const integracoes = [
    { nome: "IFOOD", link: "/waiter/formulario" },
    { nome: "WAYMENU", link: "/waymenu" },
    { nome: "WABIZ", link: "/waiter/formulario" },
    { nome: "OI MENU", link: "/waiter/formulario" },
  ];

  return (
    <IntegracoesSection>
      <Container>
        <Title>INTEGRAÇÕES</Title>
        <Grid>
          {integracoes.map((item, i) => (
            <Card key={i}>
              <IntegracaoNome>{item.nome}</IntegracaoNome>

              <Botao
                onClick={(e) => {
                  e.preventDefault();
                  integracao_Click(item);
                }}
              >
                {" "}
                <SpanSaibaMais> Saiba mais</SpanSaibaMais>
              </Botao>
            </Card>
          ))}
        </Grid>
      </Container>
    </IntegracoesSection>
  );
}

export default function PageWaiter() {
  const formularioRef = useRef(null);

  const rolarParaFormulario = () => {
    console.log(formularioRef);
    if (formularioRef.current) {
      formularioRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.min.js");
  }, []);

  return (
    <PageLayout>
      <SecaoPagina $paddingmin={"2em"} $bgcolor={"#870000"} $position={"left"}>
        <BlocoTituloTextoBotaoImagem
          imagem={TelasAplicacao}
          tituloTipoB={true}
          titulo1="Tecnologia para alimentar seu negócio"
          paragrafo1="Com o Waiter o seu negócio ganha agilidade nos processos. A gestão de mesas simples e eficaz, podendo lançar por tablets ou smartphones."
          botao1={<BotaoFaleConosco />}
          botao2={<BotaoReceberLigacao />}
          textoAbaixoImagem="PDV + ERP Desktop Completo"
          corTextoAbaixoImagem="white"
          imageAlignment="right"
          corParagrafo="white"
          styleImagem={{
            width: "600px",
          }}
        />
      </SecaoPagina>
      <Section2 $bg={TransFundo} $py="5rem">
        <Inner>
          <ProdutosGrid>
            {produtos.map((p) => (
              <ProdutoRow key={p.nome} $reverso={p.reverso}>
                <ProdutoTexto>
                  <ProdutoNome>{p.nome}</ProdutoNome>
                  <ProdutoDescricao>{p.descricao}</ProdutoDescricao>
                  <BotaoSaiba onClick={rolarParaFormulario}>
                    saiba mais
                  </BotaoSaiba>
                </ProdutoTexto>

                <ProdutoImagemWrapper>
                  <ProdutoImagem
                    $bg={p.reverso ? "transparent" : "transparent"}
                  >
                    <IconeFrame>
                      <img
                        src={p.imagemUrl}
                        alt="Ícone"
                        width="400"
                        height="400"
                      />
                    </IconeFrame>
                  </ProdutoImagem>
                </ProdutoImagemWrapper>
              </ProdutoRow>
            ))}
          </ProdutosGrid>
        </Inner>
      </Section2>

      <SecaoIntegracoes rolarParaFormulario={rolarParaFormulario} />
      <Section>
        <Content>
          <Title2>DIFERENCIAIS</Title2>

          <CardsGrid>
            {diferenciais.map((item) => (
              <Card2 key={item.id}>
                <CardIcon>{item.icone}</CardIcon>
                <CardTitle>{item.titulo}</CardTitle>
                <CardDescription>{item.descricao}</CardDescription>
                <Link to={item.link}>
                  <SaibaMaisLink
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      rolarParaFormulario();
                    }}
                  >
                    Saiba mais →
                  </SaibaMaisLink>
                </Link>
              </Card2>
            ))}
          </CardsGrid>

          <ButtonsContainer>
            <ActionButton onClick={rolarParaFormulario}>
              Saiba mais
            </ActionButton>
          </ButtonsContainer>
          <br />
          <ButtonsContainer>
            <BotaoFaleConosco />
            <BotaoReceberLigacao />
          </ButtonsContainer>
        </Content>
      </Section>

      <SecaoPagina
        $bg={"white"}
        $paddingmin={"2em 2em 9em"}
        $paddingmid={"2em 2em 9em"}
        $paddingmax={"4em 4em 8em"}
        id={"formLigacao"}
      >
        <Form
          refs={formularioRef}
          formProduto={true}
          nomeProduto={"Waychef"}
          titulo={"Tecnologia para alimentar seu negócio"}
          subtitulo={
            "Com o Waiter o seu negócio ganha agilidade nos processos.A gestão de mesas simples e eficaz , podendo lançar por tablets ou smartphones"
          }
          trabalheConosco={false}
          color={"black"}
          $bgcolor={"#870000"}
        />
      </SecaoPagina>
    </PageLayout>
  );
}
